// extracted by mini-css-extract-plugin
export default {"actions":"Portfolio_actions__C3Hgp","onlyButton":"Portfolio_onlyButton__9+AgO"};